export enum CsvHelpers {
  NEW_LINE = '\n',
  END_OF_LINE = '\r\n',
  SEPARATOR = ',',
  EMPTY_CELL = '',
  EMPTY_HEADER = 'NN',
  EXTENSION = 'csv',
  FILE_TYPE = 'text/csv;encoding:utf-8',
}
